

export default {

    created() {

        let t = this;

        let tmpF = JSON.parse(localStorage['_tmpF'] ? localStorage['_tmpF'] : "{}");

        mirrorSet(t.originF, t.f);

        mirrorSet(tmpF, t.f);

        for (let i = 0; i < 9; i++) {
            t.list.people.push({
                name: '',
                tel_country: '',
                tel: '',
                email: '',
                local_address: '',
                belong: 1,
                birthday: '',
                passport_url: '',
                passport_no: '',
                passport_data: null,
                dcode: '',
                same_as_leader_tel: false,
                same_as_leader_email: false,
                same_as_leader_local_address: false,
            });
        }

        let tmpF2 = JSON.parse(localStorage['_tmpF2'] ? localStorage['_tmpF2'] : "[]");

        if (tmpF2.length > 0)
            t.list.people = tmpF2;


        // if (t.f.guest_num > 0)
        //     t.onGuestNumChange(t.f.guest_num);

        // if (t.f.foreigner_num > 0)
        //     t.onForeignerNumChange(t.f.foreigner_num);

        // if (t.f.rc_foreigner_num > 0)
        //     t.onRCForeignerNumChange(t.f.rc_foreigner_num);

        // if (t.f.japanese_num > 0)
        //     t.onJapaneseNumChange(t.f.japanese_num);

        // if (t.f.rc_urls) {
        //     let urls = t.f.rc_urls.split(',');

        //     t.passportUploader.items2 = [];
        //     urls.forEach(url => {
        //         t.passportUploader.items2.push(({ success: true, img_url: url, validation: false }));
        //     });
        // }

        // if (t.f.passport_urls) {
        //     let urls = t.f.passport_urls.split(',');
        //     let passportData = JSON.parse(t.f.passport_data);

        //     t.passportUploader.items = [];

        //     let i = 0;
        //     urls.forEach(url => {
        //         let data = passportData[i];
        //         t.passportUploader.items.push(({ success: true, data: data, img_url: url, validation: true }));
        //         i++;
        //     });
        // }

        t.minDate = new Date();
        t.maxDate = new Date();
        t.minDate2 = new Date();
        t.maxDate2 = new Date();

        t.maxDate.setDate(t.maxDate.getDate() + 365);
        t.maxDate2.setDate(t.maxDate2.getDate() + 365);

        t.list.country = window['COUNTRY_LIST'];

        t.list.country.forEach(item => {
            item.icon = 'assets/img/flag/' + item.code + '.svg';
        });

        let arr = [];
        t.list.country.forEach(item => {
            if (item.code != 'jp') {
                arr.push(item);
            }
        });

        t.list.country2 = arr;

        t.dict.country = listToDict(t.list.country, 'code');

        if (window._language == 'ja-jp') {
            t.f.lang = 1;
            t.f.tel_country = 'jp';
            t.f.dcode = '81';
        }
        else if (window._language == 'en-us')
            t.f.lang = 3;
        else if (window._language == 'zh-cn')
            t.f.lang = 4;
        else if (window._language == 'ko-kr')
            t.f.lang = 5;

        t._language = window._language;

        t.initGenderList();

        t.loadData();


    },
    activated() {

        let t = this;

    },
    methods: {

        onChangeBelong(p) {

            p.tel_country = '';
            p.dcode = '';
            p.country = '';
            if (p.belong == 3 || p.belong == 1) {
                p.tel_country = 'jp';
                p.dcode = '81';
            }
        },
        loadData() {
            let t = this;

            let p = getURLParams();
            if (p.rid) {
                axios.get('room/' + p.rid).then(res => {
                    if (res.data.status == 1) {
                        t.room = res.data.options.item;
                        t.f.room_id = t.room.id;
                        t.setRoomName();
                    }
                });
            }
            else if (p.r) {
                axios.get('room2/' + p.r).then(res => {
                    if (res.data.status == 1) {
                        t.room = res.data.options.item;
                        t.f.room_id = t.room.id;
                        t.setRoomName();
                    }
                });
            }
        },

        initGenderList() {

            let t = this;

            t.list.gender = [
                { id: 1, text: t.t('男') },
                { id: 2, text: t.t('女') },
                { id: 3, text: t.t('LGBTQ') },
            ];

            t.dict.gender = listToDict(t.list.gender);

        },

        setRoomName() {

            let t = this;

            if ([1, 2, 4].indexOf(t.f.lang) > -1)
                t.room_name = t.room.name;
            else
                t.room_name = t.room.name_en;

        },

        onChangeLang(lang) {
            let t = this;

            t.f.country = '';
            t.f.dcode = '';
            t.f.tel_country = '';
            if (lang == 1) {
                window._language = 'ja-jp';
                t.f.tel_country = 'jp';
                t.f.country = 'jp';
                t.f.dcode = '81';
            }
            else if (lang == 2) {
                window._language = 'ja-jp';
                t.f.tel_country = 'jp';
                t.f.dcode = '81';
            }
            else if (lang == 3) {
                window._language = 'en-us';
            }
            else if (lang == 4) {
                window._language = 'zh-cn';
            }
            else if (lang == 5) {
                window._language = 'ko-kr';
            }

            t._language = window._language;

            t.hasShowHint = false;

            t.setRoomName();

            t.initGenderList();

            if (window._language != localStorage['_language']) {
                localStorage['_language'] = window._language;
                t.showForm = false;
                setTimeout(() => {
                    t.showForm = true;
                    t.$forceUpdate();
                }, 50);
            }
        },

        onSelectGender(item) {
            this.f.gender = item.id;
        },

        onSelectCountry(item) {
            this.f.country = item.code;
            this.f.tel_country = item.code;
            this.f.dcode = item.dcode;
            this.syncSameAsLeaderTel();
            this.$forceUpdate();
        },

        onSelectCountry2(item, p, toggleItem) {
            p.country = item.code;
            p.tel_country = item.code;
            p.dcode = item.dcode;
            toggleItem.showCountryPopover = false;
            this.$forceUpdate();
        },

        onSelectTelCountry(item) {
            this.f.tel_country = item.code;
            this.f.dcode = item.dcode;
        },

        onSelectTelCountry2(item, p, toggleItem) {
            p.tel_country = item.code;
            p.dcode = item.dcode;
            toggleItem.showTelCountryPopover = false;
        },

        onToggleSameAsLeaderTel(p, toggleItem) {
            if (toggleItem) {
                toggleItem.showTelCountryPopover = false;
            }
        },


        resetMinDate() {
            this.minDate2 = new Date();
        },

        resetMaxDate() {
            this.maxDate2 = new Date();
            this.maxDate2.setDate(this.maxDate2.getDate() + 365);
        },

        onSelectBirthday(d) {
            this.f.birthday = d.format('yyyy/MM/dd');
            this.showDatePopover3 = false;
        },

        onSelectBirthday2(d, p) {
            console.log(d);
            p.birthday = d.format('yyyy/MM/dd');
            p.showDatePopover = false;
        },

        onSelectCheckInDate(d) {
            this.f.check_in_date = d.format('yyyy/MM/dd');
            d.setDate(d.getDate() + 1);
            this.minDate2 = d;
            this.showDatePopover = false;
        },

        onSelectCheckOutDate(d) {
            this.f.check_out_date = d.format('yyyy/MM/dd');
            d.setDate(d.getDate() - 1);
            this.maxDate2 = d;
            this.showDatePopover2 = false;
        },

        onGuestNumChange(v) {
            let t = this;
            t.f.japanese_num = 0;
            if (t.lastGuestNum > 0 && v < t.lastGuestNum && (t.f.foreigner_num > 0 || t.f.rc_foreigner_num > 0)) {
                A.safety(t.t('設定の宿泊人数が前より減りましたので、再度アップロードが必要となります。続行しますか。')).then(res => {
                    if (res.isConfirmed) {
                        t.lastGuestNum = v;
                        t.f.foreigner_num = 0;
                        t.f.rc_foreigner_num = 0;
                        t.onForeignerNumChange(0);
                        t.onRCForeignerNumChange(0);
                        t.onJapaneseNumChange(0);
                    } else {
                        t.f.guest_num = t.lastGuestNum;
                        t.$forceUpdate();
                    }
                })
            }
            else
                t.lastGuestNum = v;

        },

        onJapaneseNumChange(v) {

        },

        onForeignerNumChange(v) {
            let t = this;
            let arr = this.passportUploader.items;
            this.passportUploader.items = [];
            for (let i = 0; i < v; i++) {
                if (i < arr.length && arr[i].success) {
                    this.passportUploader.items.push(arr[i]);
                }
                else
                    this.passportUploader.items.push({ success: false, data: '', img_url: '', validation: true });
            }
            if (t.f.rc_foreigner_num + v == t.f.guest_num) {
                t.f.japanese_num = 0;
            }
        },

        onRCForeignerNumChange(v) {
            let t = this;
            let arr = this.passportUploader.items2;
            this.passportUploader.items2 = [];
            for (let i = 0; i < v; i++) {
                if (i < arr.length && arr[i].success) {
                    this.passportUploader.items2.push(arr[i]);
                }
                else
                    this.passportUploader.items2.push({ success: false, data: '', img_url: '', validation: false });
            }
            if (t.f.foreigner_num + v == t.f.guest_num) {
                t.f.japanese_num = 0;
            }
        },

        closeCropper() {
            $('.cropper-item').hide();
        },

        confirmCropper() {

            let t = this;
            // t.cropper.getCroppedCanvas({
            //     minHeight: 600,
            //     minWdith: 600,
            //     maxHeight: 1000,
            //     maxWdith: 1000,
            //     fillColor: '#fff',
            // }).toBlob((blob) => {


            //     t.closeCropper();
            // });
        },

        uploadPicture() {

            let t = this;

            if (t.busying)
                return;

            let toValidate = true;

            if (t.lastItem.belong == 1) {
                toValidate = false;
            }
            else if (t.lastItem.lang == 2) {
                toValidate = false;
            }

            ImageUploader.onSelectImage = (file) => {

                file = event.target['files'][0];

                compressImg(file, { max_height: 1000, max_width: 1000 }, function (base64, canvas) {
                    canvas.toBlob((blob) => {

                        let fd = new FormData();

                        fd.append('image', blob);

                        let url = toValidate ? 'form/validatePassport' : 'form/uploadRC';

                        t.busying = true;
                        t.passportLoading = true;
                        t.passportLoadingText = toValidate
                            ? 'パスポートを認識しています...'
                            : 'アップロード中...';

                        axios.post(url, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {

                            if (res.data.status == 1) {

                                if (toValidate) {

                                    let passportData = res.data.options.data;

                                    if (passportData) {
                                        let data = Array.isArray(passportData) ? passportData[0] : passportData;
                                        if (data) {
                                            t.lastItem.passport_url = res.data.options.img_url;
                                            t.lastItem.passport_data = data;
                                            t.applyPassportData(t.lastItem, data);
                                        }
                                    }
                                }
                                else {
                                    t.lastItem.passport_url = res.data.options.img_url;
                                }
                            }
                            else {
                                A.err(t.t('アップロードしたパスポート写真は正しく認識できませんでした。'));
                            }
                        }).catch((err) => {
                            console.error(err);
                            A.err(t.t('アップロードしたパスポート写真は正しく認識できませんでした。'));
                        }).finally(() => {
                            t.busying = false;
                            t.passportLoading = false;
                        });
                    }, 'image/jpeg', 1)
                });

                // const image = document.getElementById('cropperImg');

                // image.src = blobUrl;

                // if (t.cropper) {
                //     t.cropper.destroy();
                //     t.cropper = null;
                // }

                // image.onload = () => {
                //     t.cropper = new Cropper(image, {
                //         aspectRatio: 4 / 3,
                //         autoCropArea: 1,
                //         crop(event) {
                //         },
                //     });
                //     $('.cropper-item').show();
                // }

                event.target['value'] = '';


            };

            ImageUploader.openSelector();
        },

        startUpload(item) {

            let t = this;

            t.lastItem = item;

            if ((item.lang && item.lang == 2) || (item.belong && item.belong == 1)) {
                t.goUpload();
            }
            else {
                t.hasShowHint = true;
                t.showHint = true;
            }
        },

        goUpload() {
            let t = this;

            t.uploadPicture();
        },

        applyPassportData(item, data) {
            if (!item || !data) {
                return;
            }

            let name = data.name || data.nameEn || '';
            if (name) {
                item.name = name.replace(', ', ' ');
            }

            let birthday = this.parsePassportBirthday(data.birthDateYmd, data.birthDate);
            if (birthday) {
                item.birthday = birthday;
            }

            if (data.passportNumber) {
                item.passport_no = data.passportNumber;
            }

            let country = data.nationality;
            if (country) {
                if (country == 'DEUTSCH')
                    country = 'DEU';
                item.country = this.mapPassportCountry(country);
            }

            if (data.nationality == 'IND') {
                item.name = data.nameEn + ' ' + data.givenName;
            }

            if (data.nationality == 'SAU') {
                item.name = data.surname + ' ' + data.givenName;
            }

            if (data.nationality == 'RCK') {
                item.name = data.surname + ' ' + data.givenName;
            }

            this.$forceUpdate();
        },

        parsePassportBirthday(birthDateYmd, birthDate) {
            if (birthDateYmd) {
                let m = String(birthDateYmd).match(/(\d{4})\D+(\d{1,2})\D+(\d{1,2})/);
                if (m) {
                    return m[1] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[3]).slice(-2);
                }
            }

            if (birthDate) {
                let s = String(birthDate).replace(/\D/g, '');
                if (s.length === 6) {
                    let yy = parseInt(s.slice(0, 2), 10);
                    let mm = s.slice(2, 4);
                    let dd = s.slice(4, 6);
                    let currentYy = new Date().getFullYear() % 100;
                    let year = yy > currentYy ? (1900 + yy) : (2000 + yy);
                    return year + '-' + mm + '-' + dd;
                }
                if (s.length === 8) {
                    return s.slice(0, 4) + '-' + s.slice(4, 6) + '-' + s.slice(6, 8);
                }
            }

            return '';
        },

        mapPassportCountry(passportCountry) {
            if (!passportCountry) {
                return '';
            }

            let key = String(passportCountry).trim().toUpperCase();
            let list = this.list.country || [];
            for (let i = 0; i < list.length; i++) {
                let item = list[i];
                if (item.passport && String(item.passport).toUpperCase() === key) {
                    return item.code;
                }
            }
            return '';
        },



        submitForm() {

            let t = this;

            let f = t.f;

            if (!f.name) {
                A.err(t.t('名前を入力してください。'));
                return;
            }

            if (f.lang != 1) {
                if (!f.passport_no) {
                    if (f.lang == 2) {
                        A.err(t.t('在留カードの番号をご入力ください'));
                    }
                    else {
                        A.err(t.t('パスポート番号をご入力ください'));
                    }
                    return;
                }
                if (!f.passport_url) {
                    if (f.lang == 2) {
                        A.err(t.t('在留カードをご提出ください'));
                    }
                    else {
                        A.err(t.t('パスポートを提出してください'));
                    }
                    return;
                }
                if (!f.country) {
                    A.err(t.t('国・地域を選択してください。'));
                    return;
                }
            }
            else
                f.country = 'jp';

            // if (!f.job) {
            //     A.err(t.t('職業を入力してください。'));
            //     return;
            // }

            // if (!f.gender) {
            //     A.err(t.t('性別を入力してください。'));
            //     return;
            // }



            if (!f.tel || f.tel < 6) {
                A.err(t.t('正確な電話番号(半角英数)を入力してください。'));
                return;
            }

            if (!f.tel_country) {
                A.err(t.t('電話番号の国・地域を選択してください。'));
                return;
            }

            if (!f.email || /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z]{2,6})$/.test(f.email) == false) {
                A.err(t.t('正確なメールアドレス(半角英数)を入力してください。'));
                return;
            }

            if (!f.local_address) {
                A.err(t.t('ご住所を入力してください。'));
                return;
            }

            if (!f.check_in_date) {
                A.err(t.t('チェックイン日付を選択してください。'));
                return;
            }

            if (!f.check_out_date) {
                A.err(t.t('チェックアウト日付を選択してください。'));
                return;
            }

            if (!f.guest_num) {
                A.err(t.t('総人数を選択してください。'));
                return;
            }



            let passportData = [];
            if (f.guest_num > 1) {
                for (let i = 0; i < f.guest_num - 1; i++) {
                    let p = t.list.people[i];
                    let alertInedx = t.t("同行者") + "[" + (i + 1) + "]: ";
                    if (p.same_as_leader_tel) {
                        p.tel = f.tel;
                        p.tel_country = f.tel_country;
                    }
                    if (p.same_as_leader_email) {
                        p.email = f.email;
                    }
                    if (p.same_as_leader_local_address) {
                        p.local_address = f.local_address;
                    }
                    if (!p.local_address) {
                        A.err(alertInedx + t.t('ご住所を入力してください。'));
                        return;
                    }


                    if (!p.tel || p.tel < 6) {
                        A.err(alertInedx + t.t('正確な電話番号(半角英数)を入力してください。'));
                        return;
                    }

                    if (!p.tel_country) {
                        A.err(alertInedx + t.t('電話番号の国・地域を選択してください。'));
                        return;
                    }

                    if (p.belong != 3) {

                        if (!p.country) {
                            A.err(alertInedx + t.t('国・地域を選択してください。'));
                            return;
                        }

                        if (!p.passport_no) {
                            if (p.belong == 1) {
                                A.err(alertInedx + t.t('在留カードの番号をご入力ください'));
                            }
                            else {
                                A.err(alertInedx + t.t('パスポート番号をご入力ください'));
                            }
                            return;
                        }
                        if (!p.passport_url) {
                            if (p.belong == 1) {
                                A.err(alertInedx + t.t('在留カードをご提出ください'));
                            }
                            else {
                                A.err(alertInedx + t.t('パスポートを提出してください'));
                            }
                            return;
                        }
                    }

                    passportData.push(p);

                }
            }

            if (!t.formIsChecked) {
                A.err(t.t('ハウスルールを確認してください。'));
                return;
            }

            if (t.busying)
                return;

            t.busying = true;

            function _save() {

                t.busying = true;

                Swal.fire({
                    title: 'Submitting...',
                    html: '<span style="color:indianred;">Please stay on this page</span><br> Remaining time: <span class="seconds" style="color:indianred;">15</span> seconds. ',
                    timer: 15000,
                    timerProgressBar: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                        const content = Swal.getHtmlContainer().querySelector('.seconds');
                        window.timerInterval = setInterval(() => {
                            const timeLeft = Math.ceil(Swal.getTimerLeft() / 1000);
                            if (content) {
                                content.textContent = timeLeft;
                            }
                        }, 1000);
                    },
                    willClose: () => {
                        clearInterval(window.timerInterval);
                    }
                });

                let data = mirror(f);

                data.people_data = JSON.stringify(passportData);

                let allPassportData = [];
                if (f.passport_data) {
                    allPassportData.push(f.passport_data);
                }
                if (f.guest_num > 1) {
                    for (let i = 0; i < f.guest_num - 1; i++) {
                        let p = t.list.people[i];
                        if (p && p.passport_data) {
                            allPassportData.push(p.passport_data);
                        }
                    }
                }
                data.passport_data = JSON.stringify(allPassportData);

                data.is_new = 1;

                axios.post('form/submit', data).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {

                        try {
                            if (window.opener)
                                window.opener.postMessage('success', '*');
                        } catch (e) {

                        }
                        localStorage.removeItem('_tmpF');
                        localStorage.removeItem('_tmpF2');
                        location.href = 'https://hk.kyoran.jp/v-new-' + res.data.options.password_guid;
                    }
                    else if (res.data.status == 2) {
                        Swal.closePopup();
                        A.err(t.t('滞在期間が正しいかどうかをもう一度確認してください。'));
                    }
                    else if (res.data.status == 3) {
                        Swal.closePopup();
                        A.err(t.t('ご指定のご宿泊日について、すでにフォームが送信されています。'));
                    }
                });
            }

            let f2 = {
                room_id: t.room.id,
                check_in_date: t.f.check_in_date,
                check_out_date: t.f.check_out_date,
            };

            axios.post('form/checkDateRange', f2).then(res => {
                if (res.data.status == 1) {
                    _save();
                }
                else if (res.data.status == 2) {
                    t.busying = false;
                    A.err(t.t('滞在期間が正しいかどうかをもう一度確認してください。'));
                }
                else if (res.data.status == 3) {
                    t.busying = false;
                    A.err(t.t('ご指定のご宿泊日について、すでにフォームが送信されています。'));
                }
            });

        }
    },
    data() {
        return {
            bornDate: new Date(1950, 0, 1),
            _language: 'ja-jp',

            lastItem: null,
            showHint: false,
            hasShowHint: false,
            busying: false,
            passportLoading: false,
            passportLoadingText: 'パスポートを認識しています...',

            showForm: true,
            room: null,

            room_name: '',
            showForm: true,
            passportUploader: {
                current: null,
                items: [
                ],
                items2: []
            },

            dict: {
                gender: [],
                country: []
            },
            list: {
                country: [],
                country2: [],
                people: [],
                lang: [
                    { id: 1, text: '日本人' },
                    { id: 2, text: '「在留カード」を持ち外国人' },
                    { id: 3, text: 'English' },
                    { id: 4, text: '中文' },
                    { id: 5, text: '한국어' },
                ],
                belong: [
                    { id: 1, text: '「在留カード」を持ち外国人' },
                    { id: 2, text: '外国人' },
                    { id: 3, text: '日本人' },
                ],
                guest_num: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                foreigner_num: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                japanese_num: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                gender: []
            },

            tog: [
                {
                    open: false,
                    showCountryPopover: false,
                    showTelCountryPopover: false,
                },
                {
                    open: false,
                    showCountryPopover: false,
                    showTelCountryPopover: false,
                },
                {
                    open: false,
                    showCountryPopover: false,
                    showTelCountryPopover: false,
                },
                {
                    open: false,
                    showCountryPopover: false,
                    showTelCountryPopover: false,
                },
                {
                    open: false,
                    showCountryPopover: false,
                    showTelCountryPopover: false,
                },
                {
                    open: false,
                    showCountryPopover: false,
                    showTelCountryPopover: false,
                },
                {
                    open: false,
                    showCountryPopover: false,
                    showTelCountryPopover: false,
                },
                {
                    open: false,
                    showCountryPopover: false,
                    showTelCountryPopover: false,
                },
                {
                    open: false,
                    showCountryPopover: false,
                    showTelCountryPopover: false,
                },
            ],

            f: {
            },

            formIsChecked: false,

            originF: {
                lang: 1,
                name: '',
                gender: null,
                country: '',
                tel_country: '',
                dcode: '',
                tel: '',
                email: '',
                check_in_date: '',
                check_out_date: '',
                guest_num: 0,
                local_address: '',
                birthday: '',
                passport_url: '',
                passport_no: '',
                passport_data: null,
                message: ''
            },

            // originF: {
            //     lang: 2,
            //     name: 'Exia',
            //     gender: 1,
            //     country: 'cn',
            //     tel_country: 'cn',
            //     dcode: '86',
            //     tel: '15500001111',
            //     email: 'exia@qq.com',
            //     check_in_date: '2023/11/18',
            //     check_out_date: '2023/11/19',
            //     guest_num: 3,
            //     foreigner_num: 1,
            //     rc_foreigner_num: 1,
            //     local_address: 'void street zero 001 cell',
            //     passport_urls: '',
            //     passport_data: '',
            //     message: 'hello',
            // },

            lastGuestNum: 0,
            showGenderPopover: false,
            showCountryPopover: false,
            showTelCountryPopover: false,
            showDatePopover: false,
            showDatePopover2: false,
            showDatePopover3: false,



            minDate: null,
            maxDate: null,

            minDate2: null,
            maxDate2: null,



        };
    },
    watch: {
        'f': {
            handler(newValue, oldValue) {
                localStorage['_tmpF'] = JSON.stringify(newValue);
            },
            deep: true
        },
        'list.people': {
            handler(newValue, oldValue) {
                localStorage['_tmpF2'] = JSON.stringify(newValue);
            },
            deep: true
        }
    }
};
